<template>
  <!-- Error page-->
  <div>
    <div>
      <b-link class="brand-logo">
        <b-img
          fluid
          src="@/assets/images/logo/Udara360-logo.png"
          class="logo"
        />
      <!-- <h2 class="brand-text text-primary ml-1">
        Udara360
      </h2> -->
      </b-link>
    </div>

    <div class="">
      <div class="misc-inner p-2 p-sm-3">
        <div class="w-100 text-center">
          <h2 class="mb-1">
            Page Not Found 🕵🏻‍♀️
          </h2>
          <p class="mb-2">
            Oops! 😖 The requested URL was not found on this server.
          </p>

          <b-button
            variant="primary"
            class="mb-2 btn-sm-block"
            :to="{path:'/dashboard'}"
          >
            Back to home
          </b-button>

          <!-- image -->
          <div>
            <b-img
              fluid
              :src="imgUrl"
              alt="Error page"
            />
          </div>

        </div>
      </div>
    </div>
  </div>

<!-- / Error page-->
</template>

<script>
/* eslint-disable global-require */
import { BLink, BButton, BImg } from 'bootstrap-vue'

export default {
  components: {
    BLink,
    BButton,
    BImg,
  },
  data() {
    return {
      downImg: require('@/assets/images/pages/error.svg'),
    }
  },
  computed: {
    imgUrl() {
      if (this.$store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.downImg = require('@/assets/images/pages/error-dark.svg')
        return this.downImg
      }
      return this.downImg
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@core/scss/vue/pages/page-misc.scss';

.logo {
  width: 15%;
}
</style>
